import { render, staticRenderFns } from "./IndividualW2Forms.vue?vue&type=template&id=0b5c60eb&scoped=true&"
import script from "./IndividualW2Forms.vue?vue&type=script&lang=ts&"
export * from "./IndividualW2Forms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5c60eb",
  null
  
)

export default component.exports